import { ColumnSortType, TableColumnTypes } from '../../model/table.model';

export const tableHeaders = [
  {
    value: 'IntDocNumber',
    sort: ColumnSortType.NONE,
    name: 'ТТН',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'StateName',
    sort: ColumnSortType.NONE,
    name: 'Статус',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'CreateTime',
    sort: ColumnSortType.NONE,
    name: 'Дата створення',
    type: TableColumnTypes.DATE,
    className: 'table-header',
  },
  {
    value: 'EstimatedDeliveryDate',
    sort: ColumnSortType.NONE,
    name: 'Плановий час доставки',
    type: TableColumnTypes.DATE,
    className: 'table-header',
  },
  {
    value: 'Cost',
    sort: ColumnSortType.NONE,
    name: 'Оголошена вартість',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'CostOnSite',
    sort: ColumnSortType.NONE,
    name: 'Вартість доставки',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'Description',
    sort: ColumnSortType.NONE,
    name: 'Опис відправлення',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'SenderContactPerson',
    sort: ColumnSortType.NONE,
    name: 'Відправник',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'SendersPhone',
    sort: ColumnSortType.NONE,
    name: 'Телефон відправника',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'CitySenderDescription',
    sort: ColumnSortType.NONE,
    name: 'Місто відправника',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'BackwardDeliverySum',
    sort: ColumnSortType.NONE,
    name: 'Грошовий переказ',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'SenderAddressDescription',
    sort: ColumnSortType.NONE,
    name: 'Адреса відправника',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'RecipientContactPerson',
    sort: ColumnSortType.NONE,
    name: 'Отримувач',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'RecipientsPhone',
    sort: ColumnSortType.NONE,
    name: 'Телефон отримувача',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'CityRecipientDescription',
    sort: ColumnSortType.NONE,
    name: 'Місто отримання',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'RecipientAddressDescription',
    sort: ColumnSortType.NONE,
    name: 'Адреса отримання',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'PayerType',
    sort: ColumnSortType.NONE,
    name: 'Платник за доставку',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'RecipientDateTime',
    sort: ColumnSortType.NONE,
    name: 'Дата отримання',
    type: TableColumnTypes.DATE,
    className: 'table-header',
  },
  {
    value: 'AdditionalInformation',
    sort: ColumnSortType.NONE,
    name: 'Додаткова інформація',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'DateLastUpdatedStatus',
    sort: ColumnSortType.NONE,
    name: 'Обновленно',
    type: TableColumnTypes.DATE,
    className: 'table-header',
  },
  {
    value: 'action',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.ACTION,
    className: 'three-dot',
    actions:
      [
        { icon: 'gps_fixed', label: 'add_in_tracker', value: 'ADD_TRACKER' },
        { icon: 'delete', label: 'delete', value: 'DELETE' },
      ],
    translate: true,
  },
];
